import { Box, Grid2 as Grid } from '@mui/material';
import type { FC } from 'react';
import { ImageSanity } from '~/components/atoms/ImageSanity';
import { PortableText } from '~/components/atoms/PortableText';
import { getCompoundTestIdGenerator } from '~/utils/getCompoundTestIdGenerator';
import { isPortableTextBlockArray } from '~/utils/portableTextUtils';
import type { IconsTextVerticalProps } from './IconsTextVertical.types';

export const IconsWithTextVertical: FC<IconsTextVerticalProps> = ({ iconsWithText }) => {
  const getCompoundTestId = getCompoundTestIdGenerator('iconsWithTextVertical');

  return (
    <Grid container columnSpacing={8} rowSpacing={4} justifyContent="center">
      {iconsWithText.map((iconText) => (
        <Grid size={{ xs: 6, sm: 3 }} key={iconText._key}>
          <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column">
            {iconText.icon && (
              <Box data-testid={getCompoundTestId('image')} display="flex" justifyContent="center" mb={2} width={100}>
                <ImageSanity imageObject={iconText.icon} height={100} width={100} styles={{ display: 'block' }} />
              </Box>
            )}
            {isPortableTextBlockArray(iconText.text) && <PortableText portableText={iconText.text} />}
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};
